import React, { FC, useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from '../Button/Button';
import { cn } from '../lib/utils';
import Typography from '../Typography/Typography';
import { Dialog, DialogOverlay, DialogTrigger } from '../ui/dialog';

import UploadImageModal from './UploadImageModal/UploadImageModal';
import { UploadImagePreview } from './UploadImagePreview';

type UploadImageProps = {
  title?: string;
  description?: string;
  buttonText?: string;
  className?: string;
  onUpload?: (url: string) => void;
  isRequired?: boolean;
  selectedImageUrl?: string;
};

const UploadImage: FC<UploadImageProps> = ({
  title = '',
  description = '',
  buttonText = 'Upload',
  className,
  onUpload,
  isRequired = false,
  selectedImageUrl = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleUpload = (url: string) => {
    onUpload?.(url);
  };

  const handleRemoveImage = () => {
    onUpload?.('');
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogOverlay className="bg-alpha-80" />
      <div
        className={cn(
          'flex justify-between items-center w-[427px] py-8 px-11 bg-base-secondary rounded-md border-dashed border border-base-mutedForeground',
          selectedImageUrl && 'py-2.5 px-6',
          className
        )}
      >
        <div>
          <Typography className="flex font-medium text-p-s mb-1.5">
            {isRequired && (
              <div className="mr-1 mt-1">
                <FontAwesomeIcon
                  icon="fa-regular fa-asterisk"
                  className="h-2 w-2 text-[8px]"
                />
              </div>
            )}
            {title}
          </Typography>
          <Typography className="text-p-xs text-base-sidebarRing whitespace-pre-line">
            {description}
          </Typography>
        </div>
        <DialogTrigger asChild>
          {selectedImageUrl ? (
            <UploadImagePreview
              preview={selectedImageUrl}
              handleRemoveImage={handleRemoveImage}
            />
          ) : (
            <Button isUploadButton>{buttonText}</Button>
          )}
        </DialogTrigger>
        <UploadImageModal
          onClose={() => setIsOpen(false)}
          onUpload={handleUpload}
          selectedImageUrl={selectedImageUrl}
        />
      </div>
    </Dialog>
  );
};

export default UploadImage;
